import React from "react"

import {CustomIconProps} from "./type/CustomIconProps"

export const JackhammerIcon = ({stroke = "#307ADE", size = 17, fill = "none", ...props}: CustomIconProps) => (
    <svg width={size} height={size} viewBox="0 0 17 17" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75623 4.78076L5.04878 3.07331C4.48305 2.50758 4.48305 1.59035 5.04878 1.02462V1.02462C5.61461 0.459457 6.53137 0.459728 7.09687 1.02522L8.80432 2.73267L6.75623 4.78076Z"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.38 2.5768L14.4234 5.62019C15.0917 6.28851 15.0917 7.37207 14.4234 8.04039L10.752 11.7118C10.4178 12.046 9.87604 12.046 9.54188 11.7118L5.28839 7.45833C4.95423 7.12417 4.95423 6.58239 5.28839 6.24823L8.95982 2.5768C9.28076 2.25586 9.71605 2.07556 10.1699 2.07556C10.6238 2.07556 11.0591 2.25586 11.38 2.5768Z"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9271 11.9534L12.2196 10.246L14.2683 8.19729L15.9758 9.90474C16.5415 10.4705 16.5415 11.3877 15.9758 11.9534V11.9534C15.41 12.5192 14.4928 12.5192 13.9271 11.9534Z"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.70837 7.87744L9.12327 11.2923L7.58887 12.8267C7.4284 12.9872 7.21075 13.0774 6.98382 13.0774C6.75688 13.0774 6.53924 12.9872 6.37877 12.8267L4.17397 10.6219C3.83981 10.2878 3.83981 9.746 4.17397 9.41185L5.70837 7.87744Z"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.36173 10.8098L1.53032 13.6412C1.39539 13.7758 1.30338 13.9473 1.26592 14.1341L1.00922 15.4253C0.977878 15.5835 1.02754 15.747 1.14161 15.8611C1.25568 15.9751 1.41913 16.0248 1.57738 15.9935L2.86859 15.7368C3.0554 15.6993 3.22692 15.6073 3.36145 15.4724L6.19286 12.6409"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.99027 4.96191L8.27893 6.67325" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.0387 7.0105L10.3274 8.72183" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
